/** Shared query params applied to every Employee lookup dropdown.
 *
 *  Drivers / technicians / responsible-person / etc. picks should:
 *   - hide Archived employees (so the list reflects who's currently active)
 *   - sort alphabetically by full name ascending (predictable scanning)
 *
 *  Imported by both the config-driven RefSelect/MultiRefSelect and the
 *  onboarding-tasks RefInput. Putting it in `lib/` (not `pages/`) avoids a
 *  layering reversal where shared components depend on page-level code. */
export const EMPLOYEE_REF_QUERY = {
  status: 'Active',
  sort: 'fullName',
  order: 'asc',
} as const;

/** Shared query params applied to every Asset lookup dropdown.
 *
 *  Fleet # values are mixed alphanumeric ("573- Bobcat S130" etc.). A plain
 *  string sort would put "10" before "9"; the Asset model auto-derives a
 *  numeric prefix into `fleetNumberSort` for natural ordering — use that as
 *  the sort key so the dropdown matches the printed reports. Status filter
 *  hides Archived / Disposed assets so picks are limited to the live fleet. */
export const ASSET_REF_QUERY = {
  vehicleStatus: 'Active',
  sort: 'fleetNumberSort',
  order: 'asc',
} as const;
